import { Button, lighten, Stack, SxProps, Theme, useTheme } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'

import { partializeLinks } from '~/features/chatbot/components/socialLinks/utils'
import { getChatbotAccentColor } from '~/features/chatbot/utils'
import { EChatbotTheme } from '~/features/settings/models'
import { store } from '~/store'
import rem, { getWhiteOrBlackTextColorByBackground } from '~/utils/ui'

type TProps = {
  setShowChatbot: Dispatch<SetStateAction<boolean>>
}

function Intro({ setShowChatbot }: TProps) {
  const theme = useTheme()
  const [chatbotAgent, chatbotLayout] = store((state) => [
    state.chatbot.agent,
    state.chatbot.layout,
  ])
  const [, agentLinks] = partializeLinks(chatbotAgent.customLinks ?? [])

  const { accentColor } = getChatbotAccentColor({
    layout: chatbotLayout,
    selectedTheme: EChatbotTheme.linkView,
  })
  const textColor = getWhiteOrBlackTextColorByBackground(accentColor, theme)

  const buttonLinkStyles: SxProps<Theme> = {
    backgroundColor: accentColor,
    color: textColor,
    width: 'initial',
    height: 'initial',
    minWidth: 'initial',
    minHeight: 'initial',
    borderRadius: rem(8),
    letterSpacing: 0,
    fontWeight: 400,
    transition: 'transform 0.2s ease-in-out',
    ':hover': {
      backgroundColor: lighten(accentColor, 0.1),
      transform: 'scale(1.02)',
    },
  }

  return (
    <Stack
      spacing={1}
      sx={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: rem(32) }}
    >
      <Button onClick={() => setShowChatbot(true)} sx={buttonLinkStyles}>
        Chat now!
      </Button>

      {agentLinks.map(({ label, url }, index) => (
        <Button
          href={url}
          key={`${label}-${index.toString()}`}
          sx={buttonLinkStyles}
          target="_blank"
        >
          {label}
        </Button>
      ))}
    </Stack>
  )
}

export default Intro
